var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.66572,
    cy: 6.53486,
    r: 5.4792,
    stroke: "#262B41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04551 16.9558C0.879007 17.1761 0.922611 17.4897 1.14291 17.6562C1.3632 17.8227 1.67677 17.7791 1.84327 17.5588L1.04551 16.9558ZM5.79936 10.6663L1.04551 16.9558L1.84327 17.5588L6.59712 11.2693L5.79936 10.6663Z",
    fill: "#262B41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchActive);
export default __webpack_public_path__ + "static/media/search-active.2a69d0c19692082aedfe509763658028.svg";
export { ForwardRef as ReactComponent };